module.exports = __webpack_public_path__ + "static/media/wide.c88425f2.jpg";